export default __webpack_public_path__ + "static/media/Logo.fa9ae56b.svg";